import { useMediaQuery, useTheme } from '@mui/material';

import { useStyles } from './facts-about-brand.styles';
import brandTrust from '../../../../../assets/images/brand-pages/facts-about-brand/brand-trust.png';
import { Header } from '../../layout-primary/header';
import { Footer } from '../../../../common/footer';
import brandTrustMobile from '../../../../../assets/images/brand-pages/facts-about-brand/brand-trust-mobile.png';

export const BrandTrust = () => {
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <>
      {isMobile && <Header />}
      <section className={classes.root} data-testid="winners-content">
        <img src={isMobile ? brandTrustMobile : brandTrust} width={422} height={551}  alt="" />
      </section>
      {isMobile && <Footer />}
    </>
  );
};
